import React from "react";
import Title from "./title";

import { Link, injectIntl } from "gatsby-plugin-react-intl";
import { useMicroCopy } from "../hooks/microcopy";
import { copy } from "../components/copy-handling";
import { getCompleteSlug } from "../helpers/localization";

const Banner = ({ heading, node, intl }) => {
  const copies = useMicroCopy();
  const colors = node?.bannerColors === "Tanssin talo" ? "bg-yellow-plain text-pink" : "bg-white-see-through text-primary";
  const link = getCompleteSlug(node.pickedPullups?.[0], intl?.locale)
  const hasLink = !!node.pickedPullups?.[0]?.slug;

  return (
    <div className={`c-banner flex min-h-20 sm:min-h-30 -mx-p-mob sm:-mx-p-sm lg:-mx-p-lg xl:mx-0 ${colors}`}>
      <Title
        isLink={hasLink}
        to={link}
        className={"flex-grow h-full lg:text-center my-auto pl-3 pr-6 py-6 sm:px-16 lg:p-6"}
      >
        <h3>{heading}</h3>
      </Title>
      {hasLink &&
        <div className="w-0 pr-3 lg:pr-6 whitespace-no-wrap relative">
          <span
            className="absolute top-1/2 transform rotate-90 -translate-x-1/2 -translate-y-1/2 px-2"
          >
            <Link
              className="link text-center"
              to={link}
            >
              {copy(copies, "link.readmore", intl?.locale)}{" "}
              <span className="transform inline-block -rotate-90">
                ➜
            </span>
            </Link>
          </span>
        </div>
      }
    </div>
  );
};

export default injectIntl(Banner);
